export const bill = {
  selectQueryDate: '10417.0', // 我的账单页选择日期
  goExport: '10418.0', // 点击导出明细按钮
  billExport: '10420.0', // 账单确认导出点击
  dayTabClick: '10449.0', // 日账单点击
  weekTabClick: '10450.0', // 周账单点击
  monthTabClick: '10451.0', // 月账单点击

  indexOrderTimeClick: '11008.0', // 我的账单页-选择---下单时间点击
  exportOrderTimeClick: '11008.0', // 导出明细页-选择---下单时间点击

  indexDeliveryTimeClick: '11009.0', // 我的账单页-选择---配送时间点击
  exportDeliveryTimeClick: '11009.0', // 导出明细页-选择---配送时间点击

  exportGoDetail: '11010.0', // 我的账单页-账单---导出列表点击

  exportListBtnClick: '11010.0' // 我的账单页-导出列表页面-导出列表-下载账单点击
}
